import React from 'react'
import { elapsedTime } from '../../../common/howDate'

const BottomChat = ({ store, data }) => {
  return (
    <div className={`${!data.memo && 'hidden'}`}>
      <div className="duration-150 w-[300px] flex flex-col hover:scale-105 h-36 gap-2 p-3 hover:bg-[#2E2E2E]">
        <div className={`w-full h-full flex justify-center shadow-[#2E2E2E] shadow-md ${data.memo.length < 30 && 'items-center'} bg-[#2E2E2E] hover:shadow-none shadow-md shadow-gray-[#1E1E1E] overflow-y-auto duration-150 rounded-md`}>
          <p className="bg-[#2E2E2E] whitespace-normal tracking-widest p-3">
            {`${data.memo ?? '-'}`}
          </p>
        </div>
        <div className='flex gap-2 tracking-wider text-xs hover:text-gray-50 justify-between px-1 text-gray-300 font-semibold'>
          <p>{ store ?? '-' }</p>
          <p>|</p>
          <p>{ data.id ?? '-' }</p>
          <p>|</p>
          <p>{ elapsedTime(data.date) ?? '-' }</p>
        </div>
      </div>
    </div>
  )
}

export default BottomChat